import React, { useState } from "react";
import AddFBIntegtarion from "../FBIntegration";
import MessagingIntegration from "../MessagingIntegration";
import ChannelIntegration from "../ChannelIntegration";
import IntegrationGuidePanel, { INTEGRATION_GUIDES } from "../shared/IntegrationGuidePanel";
import { SaIntegrationSubTabs, SA } from "../shared/SuperAdminUi";

const INTEGRATION_TABS = [
  { key: "facebookAds", label: "Facebook Ads", icon: "fab fa-facebook", iconColor: "#1877F2" },
  { key: "googleAds", label: "Google Ads", icon: "fab fa-google", iconColor: "#4285F4" },
  { key: "linkedin", label: "LinkedIn", icon: "fab fa-linkedin", iconColor: "#0A66C2" },
  { key: "instagram", label: "Instagram", icon: "fab fa-instagram", iconColor: "#C13584" },
  { key: "ninetyNineAcres", label: "99acres", icon: "fas fa-city", iconColor: "#E84545" },
  { key: "messaging", label: "SMS & WhatsApp", icon: "fas fa-comment-dots", iconColor: "#7B61FF" },
  { key: "integrationGuide", label: "Integration guide", icon: "fas fa-book-open", iconColor: SA.primary },
];

const CHANNEL_TAB_KEYS = {
  googleAds: "GoogleAds",
  linkedin: "LinkedIn",
  instagram: "Instagram",
  ninetyNineAcres: "NinetyNineAcres",
};

function ClientIntegrationPanel({ clientId }) {
  const [activeIntegrationTab, setActiveIntegrationTab] = useState("facebookAds");

  return (
    <div style={{ marginTop: "4px" }}>
      <SaIntegrationSubTabs
        tabs={INTEGRATION_TABS}
        activeKey={activeIntegrationTab}
        onChange={setActiveIntegrationTab}
      />

      {activeIntegrationTab === "facebookAds" && <AddFBIntegtarion ClientId={clientId} />}

      {CHANNEL_TAB_KEYS[activeIntegrationTab] && (
        <ChannelIntegration ClientId={clientId} channelKey={CHANNEL_TAB_KEYS[activeIntegrationTab]} />
      )}

      {activeIntegrationTab === "messaging" && (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              marginBottom: "12px",
              gap: "8px",
            }}
          >
            <button
              type="button"
              onClick={() => setActiveIntegrationTab("integrationGuide")}
              style={{
                border: "none",
                background: "transparent",
                color: SA.primary,
                fontWeight: 700,
                fontSize: "13px",
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                padding: "4px 0",
              }}
            >
              <i className="fas fa-book-open" />
              Integration guide
              <i className="fas fa-arrow-right" style={{ fontSize: "11px" }} />
            </button>
          </div>
          <MessagingIntegration ClientId={clientId} />
        </>
      )}

      {activeIntegrationTab === "integrationGuide" && (
        <>
          <p style={{ margin: "0 0 16px", fontSize: "14px", color: SA.muted, lineHeight: 1.6 }}>
            Setup notes for each channel. Configure credentials in the matching tab — including{" "}
            <button
              type="button"
              onClick={() => setActiveIntegrationTab("messaging")}
              style={{
                border: "none",
                background: "transparent",
                color: SA.primary,
                fontWeight: 700,
                cursor: "pointer",
                padding: 0,
                fontSize: "inherit",
              }}
            >
              SMS &amp; WhatsApp
            </button>
            .
          </p>
          {INTEGRATION_GUIDES.map((guide) => (
            <IntegrationGuidePanel key={guide.key} {...guide} />
          ))}
        </>
      )}
    </div>
  );
}

export default ClientIntegrationPanel;
